var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.177,
    height: 17.176,
    viewBox: "0 0 17.177 17.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "newtab",
    d: "M15.037,17.176H2.155a2.07,2.07,0,0,1-1.518-.629,2.065,2.065,0,0,1-.628-1.518V4.294L.813,1.677a2.249,2.249,0,0,1,.981-1.2A2.917,2.917,0,0,1,3.4,0H9.5a2.917,2.917,0,0,1,1.6.478,2.249,2.249,0,0,1,.981,1.2l.805,2.617h2.147a2.147,2.147,0,0,1,2.147,2.147v8.588a2.147,2.147,0,0,1-2.147,2.147Zm0-10.2a.545.545,0,0,0-.537-.537H2.692a.545.545,0,0,0-.537.537v7.515a.545.545,0,0,0,.537.537H14.5a.545.545,0,0,0,.537-.537Zm-4.294,4.831H9.669v1.074a1.073,1.073,0,0,1-2.146,0V11.809H6.45a1.074,1.074,0,1,1,0-2.147H7.523V8.588A1.088,1.088,0,0,1,8.6,7.515a1.045,1.045,0,0,1,.755.31,1.024,1.024,0,0,1,.319.763V9.662h1.074a1.045,1.045,0,0,1,.755.31,1.073,1.073,0,0,1,0,1.526,1.045,1.045,0,0,1-.755.31Z",
    transform: "translate(-0.008)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProject);
export default __webpack_public_path__ + "static/media/new_project.4f31b57465ad7d12d52cc7d985815bd2.svg";
export { ForwardRef as ReactComponent };